import { schema } from 'normalizr'

import UserSchema from '../../users/schema'

const CommentSchema = new schema.Entity('comments', { user: UserSchema })

export default CommentSchema
